import { IQueryStringNavLinks } from "../../interfaces-and-types";
import { View } from "./View";

export const Reconciliation = () => {
  const queryStringTabs: IQueryStringNavLinks = {
    query: "",
    options: [
      {
        key: "Payout Reconciliation",
        value: "",
      },
    ],
  };

  return <View queryStringTabs={queryStringTabs} />;
};
